import { Box, Card, Grid, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"

export const StyledTwoButtonGrid = styled(Grid)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  alignItems: "baseline",

  [theme.breakpoints.down("lg")]: {
    gap: "16px"
  },
  [theme.breakpoints.up("md")]: {
    alignItems: "center"
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    width: "100%"
  }
}))

export const StyledWrapCard = styled(Card)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  flexDirection: "row",
  padding: theme.spacing(5),
  [theme.breakpoints.down("md")]: {
    flexWrap: "wrap",
    padding: theme.spacing(3),
    flexDirection: "column"
  }
}))

export const StyledInlineBox = styled(Grid)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "space-between",
  padding: `${theme.spacing(3)} ${theme.spacing(4)}`,
  borderRadius: "12px",
  backgroundColor: theme.palette.background.default,
  [theme.breakpoints.down("sm")]: {
    padding: theme.spacing(2)
  }
}))

export const StyledInlineBoxLabel = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
  color: theme.palette.text.secondary
}))

export const StyledInlineGrid = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    display: "inline"
  }
}))
